module.exports = __webpack_public_path__ + "img/P150T_weapon_24.dbf63189.png";